// ============================================
// STORE DE AUTENTICACIÓN (Pinia)
// ============================================
// Fuente única de verdad para la sesión. sessionStorage queda como capa de
// persistencia interna (y para compatibilidad con código aún no migrado).
//
// Uso:
//   import { useAuthStore } from '@/stores/auth';
//   const auth = useAuthStore();
//   auth.isAuthenticated / auth.user / auth.logout()

import { defineStore } from 'pinia';
import { getUserFromToken, performLogout, persistSharedToken, esSuperAdmin, getRolActual } from '../utils/auth';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: sessionStorage.getItem('token') || ''
  }),

  getters: {
    isAuthenticated: (state) => Boolean(state.token),
    user: (state) => (state.token ? getUserFromToken() : null),
    // Rol en el proyecto activo y flag de superadmin global (fuente única)
    rol: (state) => (state.token ? getRolActual() : null),
    esSuperAdmin: (state) => (state.token ? esSuperAdmin() : false)
  },

  actions: {
    setToken(token) {
      this.token = token || '';
      if (this.token) {
        sessionStorage.setItem('token', this.token);
        persistSharedToken(this.token);
      } else {
        sessionStorage.removeItem('token');
        localStorage.removeItem('hb:token');
      }
    },

    /** Re-lee sessionStorage (p. ej. tras eventos hb:session-updated) */
    syncFromStorage() {
      this.token = sessionStorage.getItem('token') || '';
    },

    logout() {
      this.token = '';
      performLogout({ redirectTo: '/login', broadcast: true });
    }
  }
});
